import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    maxWidth: 'none !important',
  },
}))
export default styles
